import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../client';
import { qk } from './keys';
import type { PaginatedResponse, Wallet, WalletTransaction } from '../types';

export function useWallet() {
  return useQuery({
    queryKey: qk.wallet,
    queryFn: () => apiGet<Wallet>('/wallet'),
    staleTime: 15_000,
  });
}

export function useWalletTransactions(limit = 20) {
  return useQuery({
    queryKey: [...qk.walletTx, limit] as const,
    queryFn: () =>
      apiGet<PaginatedResponse<WalletTransaction>>(`/wallet/transactions?limit=${limit}`),
  });
}
